import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Global
import React from 'react';
import { tv } from 'tailwind-variants';
// Local
import useDictionary from 'lib/hooks/useDictionary';
import { smoothScrollToElement } from 'lib/hooks/useScrollElementIntoView';
import { SvgIcon } from 'helpers/SvgIcon';
import PlainTextWrapper from 'helpers/SitecoreWrappers/PlainTextWrapper/PlainTextWrapper';
import { getTestProps } from 'lib/testing/utils';
import { editingHydrationProps } from 'lib/hooks/useEditingHydrationProps';
import useIsEditing from 'lib/hooks/useIsEditing';
const SkipNav = ()=>{
    const isEditing = useIsEditing();
    const { base } = TAILWIND_VARIANTS();
    const { getDictionaryValue } = useDictionary();
    /*
   * Rendering
   */ return /*#__PURE__*/ _jsx("div", {
        "data-component": "authorable/shared/site-structure/skipnav/skipnav",
        ...editingHydrationProps(isEditing),
        ...getTestProps(`component-skip-nav`),
        children: /*#__PURE__*/ _jsxs("button", {
            className: base(),
            role: "button",
            ...getTestProps(`link`),
            "aria-label": getDictionaryValue('SkipToMainContent') || 'Skip to main content',
            onClick: ()=>{
                const elem = document.getElementById('main-content');
                if (elem) {
                    smoothScrollToElement(elem, 'header', null, 0, undefined, ()=>{
                        elem.setAttribute('tabindex', '-1');
                        elem.focus({
                            preventScroll: true
                        });
                        elem.removeAttribute('tabindex');
                    });
                }
            },
            children: [
                /*#__PURE__*/ _jsx(SvgIcon, {
                    icon: "arrow-down",
                    size: "s"
                }),
                /*#__PURE__*/ _jsx(PlainTextWrapper, {
                    field: {
                        value: getDictionaryValue('SkipToMainContent') || 'Skip to main content'
                    },
                    tag: "p"
                })
            ]
        })
    });
};
export default SkipNav;
const TAILWIND_VARIANTS = tv({
    slots: {
        base: [
            'left-1',
            'sr-only',
            'top-1',
            'focus:absolute',
            'focus:!bg-white',
            'focus:!text-component-button-primary-filled-text-hover',
            'focus:font-typography-font-family-body',
            'focus:text-typography-font-size-body-large',
            'focus:shadow-2xs',
            'focus:shadow-color-border-border-focus',
            'focus:!outline-color-border-border-focus',
            'focus:outline-none',
            'focus:ring-4',
            'focus:ring-offset-1',
            'focus:ring-color-border-border-focus',
            'focus:flex',
            'focus:items-center',
            'focus:gap-spacing-spacing-8',
            'focus:not-sr-only',
            'focus:py-spacing-spacing-16',
            'focus:px-spacing-spacing-24',
            'focus:border-general-border-width-button',
            'focus:border-component-button-primary-filled-border-focused',
            'focus:rounded-general-border-radius-button',
            'focus:z-[100]'
        ]
    }
});
